import React from 'react';
const NAV_LINKS = [{
  id: 'inicio',
  label: 'Inicio'
}, {
  id: 'quienes-somos',
  label: 'Quiénes somos'
}, {
  id: 'como-pensamos',
  label: 'Cómo pensamos'
}, {
  id: 'servicios',
  label: 'Servicios'
}, {
  id: 'modalidades',
  label: 'Modalidades'
}];
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-petrol-dark pt-14 pb-10" data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10" data-id="element-63">
          {/* Col 1: Brand */}
          <div className="lg:col-span-1" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/hVCVqUWzZjwSreG1M31DmC/Diseno_sin_titulo.png" alt="eficci logo" className="h-10 w-auto object-contain mb-6 brightness-0 invert opacity-90" data-id="element-65" />
            <p className="font-body text-sm text-silver-main leading-relaxed" data-id="element-66">
              Consultoría de incidencia y políticas públicas. La nueva
              arquitectura de la gobernanza.
            </p>
          </div>

          {/* Col 2: Nav */}
          <div className="lg:col-span-1" data-id="element-67">
            <h4 className="font-body text-xs font-semibold uppercase tracking-widest text-silver-dark mb-6" data-id="element-68">
              Navegación
            </h4>
            <ul className="space-y-3" data-id="element-69">
              {NAV_LINKS.map(link => <li key={link.id} data-id="element-70">
                  <button onClick={() => scrollToSection(link.id)} className="font-body text-sm text-silver-main hover:text-white transition-colors" data-id="element-71">
                    {link.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Contact */}
          <div className="lg:col-span-1" data-id="element-72">
            <h4 className="font-body text-xs font-semibold uppercase tracking-widest text-silver-dark mb-6" data-id="element-73">
              Contacto
            </h4>
            <ul className="space-y-3 font-body text-sm text-silver-main" data-id="element-74">
              <li data-id="element-75">
                <a href="tel:+5491122438278" className="hover:text-white transition-colors" data-id="element-76">
                  +54 9 11 2243 8278
                </a>
              </li>
              <li data-id="element-77">
                <a href="mailto:eficciconsultores@gmail.com" className="hover:text-white transition-colors" data-id="element-78">
                  eficciconsultores@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Location */}
          <div className="lg:col-span-1" data-id="element-79">
            <h4 className="font-body text-xs font-semibold uppercase tracking-widest text-silver-dark mb-6" data-id="element-80">
              Ubicación
            </h4>
            <address className="font-body text-sm text-silver-main not-italic leading-relaxed" data-id="element-81">
              Buenos Aires,
              <br data-id="element-82" />
              Argentina
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-83">
          <p className="font-body text-xs text-silver-dark" data-id="element-84">
            © {new Date().getFullYear()} eficci. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-6" data-id="element-85">
            <a href="#" className="font-body text-xs text-silver-dark hover:text-white transition-colors" data-id="element-86">
              Aviso legal
            </a>
            <a href="#" className="font-body text-xs text-silver-dark hover:text-white transition-colors" data-id="element-87">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}